<template>
  <div class="container">
    <div class="nav-con">
      <div class="logo"></div>
      <div class="gallery" @click="onGalleryClick">应用图库</div>
      <div class="icon" @click="handleMenuChange">U</div>
      <!--      <div v-show="menuVisible" class="menu-list">-->
      <!--        <div @click="goPage(1)" class="item">我的待办</div>-->
      <!--        <div @click="goPage(2)" class="item">我的文档</div>-->
      <!--        <div @click="goPage(3)" class="item">我的乐问</div>-->
      <!--        <div @click="goPage(4)" class="item">我的活动</div>-->
      <!--        <div @click="goPage(5)" class="item">我的项目</div>-->
      <!--        <div @click="goPage(6)" class="item">我的收藏</div>-->
      <!--      </div>-->
    </div>
    <div class="banner">
      <div class="title">集思共创&nbsp;&nbsp;聚光成火</div>
      <div class="search-con">
        <!-- <el-input v-model="searchText" @keyup.enter="handleSearch" placeholder="搜索文档资源"></el-input> -->
        <el-input placeholder="搜索文档资源" v-model="searchText" class="input-with-select" clearable @keyup.enter="handleSearch" @clear="handleClear">
          <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
        </el-input>
        <!-- <input v-model="searchText" @keyup.enter="handleSearch" type="search" placeholder="搜索文档资源" />
        <div class="btn" @click="handleSearch"></div> -->
      </div>
      <div class="tip">
        关键词：
        <span @click="handleKeyClick(key)" :key="'word' + index"
          v-for="(key, index) in categoryInfo.recommendCategories">
          <template v-if="index < categoryInfo.recommendCategories.length - 1">{{ key }}、</template>
          <template v-else>{{ key }}</template>
        </span>
      </div>
    </div>
    <div class="filter-con" v-if="showFilter">
      <div class="filter1">
        <div @click="changeMenu(item.categoryId)" v-for="item in categoryInfo.categories" :key="item.categoryId"
          :class="[menu == item.categoryId ? 'active' : '']">{{ item.categoryName }}</div>
      </div>
      <div class="filter2-con">
        <div class="filter2">
          <div class="cate-level2-item" :key="item.categoryId" v-for="item in subMenuList">
            <div :class="['name', item.selectName != '' ? 'active' : '']" @click="handleSubMenuChange(item)">
               {{item.selectName || item.categoryName }}
             
              <span :class="['arrow', activeSubMenuId == item.categoryId ? 'close' : 'open']"
              @click.stop="handleThreeLevelOpen(item)" v-if="item.threeLevelChildren.length > 1"></span>
            </div>
          </div>
        </div>
        <div v-show="subMenuVisible" class="smenu-con">
          <div class="menu">
            <div :class="['item', tmpSelectedIds.indexOf(item.categoryId) > -1 ? 'active' : '']"
              @click="handleLastMenuChange(item)" :key="item.categoryId" v-for="item in threeMenuList">{{
                item.categoryName
              }}</div>
          </div>
          <!-- <div class="boot">
            <div @click="handleFilterCancel">取消</div>
            <div @click="handleFilterSubmit" class="ok">确定</div>
          </div> -->
        </div>
      </div>
      <div class="filter3">
        <div @click="changeHot(2)" :class="[hot == 2 ? 'active' : '']">最新</div>
        <div @click="changeHot(1)" :class="[hot == 1 ? 'active' : '']">最热</div>
      </div>
    </div>

    <div class="list-con">
      <div class="list">
        <div class="item" @click="goUrl(item.link)" v-for="item in list" :key="item.id">
          <div class="img" :style="{
            background: `url('${item.pictureLocation}') no-repeat center center / 100% 100%`,
          }"></div>
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.createTime | dateFormatter }}</div>
            <div class="bootom">
              <div class="author">{{ item.author }}</div>
              <div class="view"></div>
              <div class="count">{{ item.readCount }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="list.length == 0" class="loading">暂无任何数据</div>
      <div v-else>
        <div v-if="nomore" class="loading">已经到达最底部</div>
        <div v-else class="loading">加载中...</div>
      </div>
    </div>
    <div v-show="maskVisible" @touchmove.prevent @click="handleMaskClick" class="mask"></div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "mdhome",
  data() {
    return {
      menu: "",
      menu2: "",
      hot: 2,
      showFilter: true,
      categoryInfo: {
        categories: []
      },
      selectedIds: [],
      tmpSelectedIds: [],
      searchText: "",
      pageNum: 1,
      totalPages: 0,

      list: [],

      loadinng: false,
      nomore: false,
      menuVisible: false,
      maskVisible: false,
      activeSubMenuId: "",
      subMenuVisible: false,
      subMenuMoreVisible: false,
      currentTwoMenu: {},
      currentLastMenu: {}
    };
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    }
  },
  mounted() {
    let searchTxt = sessionStorage.getItem("hsearch");
    if (searchTxt) {
      //判断路由
      this.searchText = searchTxt;
      sessionStorage.removeItem("hsearch");
    }
    window.addEventListener("scroll", this.handleScroll, true);
    this.getCateList();

    // this.categoryInfo = this.dataList
    // this.menu = this.categoryInfo.categories[0].categoryId
    // this.initMenu()
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    subMenuList() {
      let result = this.categoryInfo.categories.find(
        item => item.categoryId == this.menu
      );
      return result && result.twoLevelChildren;
    },
    subMenuListMore() {
      let data = [];
      let result = this.categoryInfo.categories.find(
        item => item.categoryId == this.menu
      );
      if (result) {
        if (result.twoLevelChildren.length > 3) {
          data = result.twoLevelChildren.slice(3);
        }
      }
      return data;
    },
    threeMenuList() {
      let result = [];
      let oneLevelObj = this.categoryInfo.categories.find(
        item => item.categoryId == this.menu
      );
      if (oneLevelObj) {
        if (oneLevelObj.twoLevelChildren) {
          const twoLevelObj = oneLevelObj.twoLevelChildren.find(
            item => item.categoryId == this.activeSubMenuId
          );
          if (twoLevelObj != undefined) {
            result = twoLevelObj.threeLevelChildren.filter(
              item => item.categoryName != "全部"
            );
          }
        }
      }
      return result;
    }
  },
  methods: {
    onGalleryClick() {
      this.$router.push("/gallery");
    },
    handleKeyClick(key) {
      console.log(key);
      this.searchText = key;
      this.handleSearch();
    },
    goUrl(link) {
      if (link) {
        sessionStorage.setItem("hsearch", this.searchText);
        window.location.href = link;
      }
    },
    // goPage(id) {
    //   console.log(id)
    //   if (id == 3) {
    //     window.location.href =
    //       'https://lexiangla.com/questions?company_from=db4cbf76a76111ec93886a56b1ecba05'
    //   }
    //   this.menuVisible = false
    //   this.maskVisible = false
    // },
    handleMaskClick() {
      this.subMenuVisible = false;
      this.subMenuMoreVisible = false;
      this.menuVisible = false;
      this.maskVisible = false;
    },
    handleClear() {
      this.handleSearch()
    },
    handleSearch() {
      if(this.searchText?.length>0){
        this.menu = undefined
        this.showFilter = false
        this.selectedIds = undefined
      }else{
        const categoryId = this.categoryInfo.categories[0].categoryId;
        this.menu = categoryId
        this.selectedIds = [categoryId]
        this.showFilter = true
      }
     
      this.pageNum = 1;
      this.getDocList();
    },
    handleFilterCancel() {
      this.subMenuVisible = false;
      this.subMenuMoreVisible = false;
      this.maskVisible = false;
      this.activeSubMenuId = "";
      this.tmpSelectedIds = [...this.selectedIds];
    },
    handleFilterSubmit() {
      //清楚掉之前的

      this.clearSelected();
      this.currentTwoMenu.selectName = this.currentLastMenu.categoryName || "";

      this.selectedIds = [...this.tmpSelectedIds];
      this.subMenuVisible = false;
      this.subMenuMoreVisible = false;
      this.maskVisible = false;
      this.activeSubMenuId = "";
      this.pageNum = 1;
      this.getDocList();
    },
    handleLastMenuChange(item) {
      if (this.currentLastMenu.categoryId === item.categoryId) {
        this.currentLastMenu = {};
      } else {
        this.currentLastMenu = item;
      }
      if (this.tmpSelectedIds.indexOf(item.categoryId) > -1) {
        this.tmpSelectedIds = [];
      } else {
        this.tmpSelectedIds = [item.categoryId];
      }

      this.handleFilterSubmit()
    },
    handleSubMenuMoreVisible() {
      this.currentTwoMenu = {};
      this.subMenuVisible = false;
      this.subMenuMoreVisible = !this.subMenuMoreVisible;
      this.maskVisible = true;
    },

    handleSubMenuChange(item) {
      console.log(item, "二级");

      //也去查询
      if (this.selectedIds.indexOf(item.categoryId) > -1) {
        item.selectName = "";
        this.tmpSelectedIds = [];
        this.selectedIds = [];
      } else {
        this.clearSelected();
        this.tmpSelectedIds = [item.categoryId];
        this.selectedIds = [item.categoryId];
        item.selectName = item.categoryName;
      }
      this.activeSubMenuId = ""
      this.subMenuVisible = false;
      this.maskVisible = false;
      this.pageNum = 1;
      this.getDocList();


      // if (item.threeLevelChildren.length <= 1) {
      //   //也去查询
      //   if (this.selectedIds.indexOf(item.categoryId) > -1) {
      //     item.selectName = "";
      //     this.tmpSelectedIds = [];
      //     this.selectedIds = [];
      //   } else {
      //     this.clearSelected();
      //     this.tmpSelectedIds = [item.categoryId];
      //     this.selectedIds = [item.categoryId];
      //     item.selectName = item.categoryName;
      //   }
      //   this.subMenuVisible = false;
      //   this.maskVisible = false;
      //   this.pageNum = 1;
      //   this.getDocList();
      //   return;
      // } else {
      //   this.currentTwoMenu = item;
      //   const cid = item.categoryId;
      //   this.subMenuMoreVisible = false;
      //   if (this.activeSubMenuId == cid) {
      //     this.activeSubMenuId = "";
      //     this.maskVisible = false;
      //     this.subMenuVisible = false;
      //   } else {
      //     this.activeSubMenuId = cid;
      //     this.maskVisible = true;
      //     this.subMenuVisible = true;
      //   }
      // }
    },
    handleThreeLevelOpen(item) {
      this.currentTwoMenu = item;
      const cid = item.categoryId;
      this.subMenuMoreVisible = false;
      if (this.activeSubMenuId == cid) {
        this.activeSubMenuId = "";
        this.maskVisible = false;
        this.subMenuVisible = false;
        item.selectName = "";
      } else {
        this.activeSubMenuId = cid;
        this.maskVisible = true;
        this.subMenuVisible = true;
        item.selectName = item.categoryName;
      }
    },
    handleMenuChange() {
      window.location.href = "https://app.wecom.work/302622/0ntdbb";
      this.menuVisible = !this.menuVisible;
      this.maskVisible = this.menuVisible;
      this.subMenuVisible = false;
      this.subMenuMoreVisible = false;
      // this.maskVisible=false
      // this.subMenuVisible=false
    },
    handleScroll() {
      if (
        document.documentElement.scrollTop + window.innerHeight >=
        document.body.offsetHeight
      ) {
        if (this.pageNum == this.totalPages || this.loadinng) {
          return;
        }
        this.pageNum++;
        this.getDocList();
      }
    },
    changeMenu(cid) {
      this.menu = cid;
      this.pageNum = 1;
      this.activeSubMenuId = "";
      this.subMenuVisible = false;
      this.subMenuMoreVisible = false;
      this.maskVisible = false;
      // this.initMenu()
      this.clearSelected();
      this.selectedIds = [cid];
      this.tmpSelectedIds = [cid];
      this.getDocList();
    },
    clearSelected() {
      this.categoryInfo.categories.forEach(item => {
        if (item.twoLevelChildren) {
          item.twoLevelChildren.forEach(sitem => {
            if (sitem.selectName != "") {
              sitem.selectName = "";
            }
          });
        }
      });
    },
    getCateList() {
      this.$request.getCategoryList().then(res => {
        console.log(res);
        if (res.code == 200) {
          let data = res.data;
          if (data.categories) {
            data.categories.forEach(item => {
              if (item.twoLevelChildren) {
                item.twoLevelChildren.forEach(sitem => {
                  sitem.selectName = "";
                });
              }
            });
          }
          this.categoryInfo = data;
          this.menu = this.categoryInfo.categories[0].categoryId;
          this.selectedIds = [this.menu];
          // this.initMenu()
        }
        this.getDocList();
      });
    },
    initMenu() {
      let menuObj = this.categoryInfo.categories.find(
        item => item.categoryId == this.menu
      );
      let selectedIds = [];
      if (menuObj.twoLevelChildren) {
        menuObj.twoLevelChildren.forEach(item => {
          item.threeLevelChildren.forEach(sitem => {
            if (sitem.categoryName == "全部") {
              selectedIds.push(sitem.categoryId);
            }
          });
        });
      }

      this.selectedIds = selectedIds;
    },
    getDocList() {
      this.nomore = false;
      this.loadinng = true;
      let postData = {
        categoryIds: this.selectedIds,
        searchContext: this.searchText,
        type: this.hot,
        pageNum: this.pageNum,
        pageSize: 10
      }
      this.$request
        .getDocumentList(postData)
        .then(res => {
          if (res.code == 200) {
            if (this.pageNum == 1) {
              this.list = res.data.records;
            } else {
              this.list = [...this.list, ...res.data.records];
            }
            this.totalPages = res.data.pages;
            if (this.totalPages == this.pageNum) {
              this.nomore = true;
            }
          }
        })
        .finally(() => {
          this.loadinng = false;
        });
    },
    changeFilter(cid) {
      this.selectedIds = [cid];
      this.getDocList();
    },
    changeHot(hot) {
      this.hot = hot;
      this.pageNum = 1;
      this.getDocList();
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 0.96rem;
  position: relative;
  transform: scale(1, 1);

  &>.nav-con {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 0;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;

    &>.logo {
      flex: 1;
      height: 0.96rem;
      background: url("~@/assets/imgs/menu_logo_mobile@3x.png") no-repeat 0.32rem center / 2.08rem auto;
    }

    &>.gallery {
      flex: 0 0 1.44rem;
      height: 0.56rem;
      border: 0.01rem solid rgba(0, 0, 0, 0.08);
      font-size: 0.14rem;
      line-height: 0.56rem;
      color: rgba(0, 0, 0, 0.85);
      border-radius: 0.08rem;
      text-align: center;
      font-size: 0.28rem;
      margin-right: 0.48rem;
      color: #e60027;
      background-color: #fff1f0;
    }

    &>.icon {
      height: 0.6rem;
      width: 0.6rem;
      //background: url('~@/assets/imgs/icon_menu_mobile@3x.png') no-repeat 0
      //  center / 0.4rem auto;
      text-align: center;
      line-height: 0.6rem;
      border-radius: 50%;
      background-color: #ffd8bf;
      color: #fa541c;
      margin-right: 0.2rem;
    }

    &>.menu-list {
      position: fixed;
      top: 0.96rem;
      left: 0;
      right: 0;
      background-color: #fff;
      padding: 0.16rem 0;
      z-index: 99;

      &>.item {
        font-size: 0.34rem;
        height: 0.96rem;
        line-height: 0.96rem;
        box-shadow: inset 0px -0.01rem 0px 0.01rem rgba(0, 0, 0, 0.06);
        padding: 0 0.16rem;
        font-weight: 400;
      }
    }
  }

  &>.banner {
    text-align: center;
    position: relative;
    z-index: 11;
    background: url("~@/assets/imgs/pic_search_bg_mobile@3x.png") no-repeat center center / 100% auto;
    padding: 0.48rem 0;

    &>.title {
      font-size: 0.4rem;
      font-weight: 400;
      color: #000;
    }

    &>.search-con {
      // display: flex;
      background-color: #fff;
      overflow: hidden;
      border-radius: 0.08rem;
      width: 5.8rem;
      margin: 0 auto;
      margin-top: 0.32rem;
      margin-bottom: 0.16rem;
      box-sizing: border-box;
      border: 1px solid #9d9d9d;

      ::v-deep input {
        padding-left: 0.32rem;
        // flex: 1;
        display: block;
        // line-height: 0.64rem;
        // height: 0.64rem;
        // line-height: 0.64rem;
        border-radius: 0.64rem;
        border: 0;
        outline: none;
        font-size: 0.28rem;
        box-sizing: border-box;
        width: 100%;
        background-color: #fff;

      }

      ::v-deep .el-input-group__append,
      input {
        background-color: #fff;
        border: 0;
      }
      ::v-deep .el-input__suffix{
        width: .52rem;
        &>span{
          position: absolute;
          top:50%;
          margin-top: -.15rem;
          left: 0;
          text-align: center;
          width:.52rem;;
          & i{
            line-height: .2rem;
            height: .2rem;
          }
        }
      }

      // ::v-deep .el-input__suffix-inner{
      //   border:1px solid red;
      //   top:50%;
      //   left: 0;
      //   position: absolute;
      // }

      &>.btn {
        flex: 0 0 0.34rem;
        padding-right: 0.32rem;
        background: url("~@/assets/imgs/icon_search@2x.png") no-repeat center center / 0.34rem auto;
      }
    }

    &>.tip {
      visibility: hidden;
      font-size: 0.24rem;
      color: rgba(255, 255, 255, 0.85);
    }
  }

  &>.filter-con {
    border-bottom: 0.02rem solid rgba(0, 0, 0, 0.04);
    padding-top: 0.32rem;
    position: relative;
    background-color: #fff;
    z-index: 11;

    &>.filter1 {
      display: flex;
      margin-left: 0.32rem;
      overflow-x: scroll;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        width: 0;
        height: 0;
      }

      &::-webkit-scrollbar {
        display: none;
      }

      &>div {
        flex: 0 0 auto;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        font-size: 0.28rem;
        background-color: #f5f5f5;
        margin-right: 0.32rem;
        border-radius: 0.08rem;
        padding: 0 0.32rem;

        &:last-child {
          margin-right: 0;
        }

        &.active {
          background-color: #e60027;
          color: #ffffff;
        }
      }
    }

    &>.filter2-con {
      position: relative;
      padding: 0 0.32rem;
      padding-top: 0.16rem;
      padding-right: 0;

      &>.filter2 {
        display: flex;
        align-items: center;
        height: 0.8rem;
        line-height: 0.8rem;
        overflow-x: auto;

        &::-webkit-scrollbar {
          width: 0;
          height: 0;
        }

        &::-webkit-scrollbar {
          display: none;
        }

        &>.cate-level2-item {
          flex: 0 0 auto;
          font-size: 0.28rem;
          margin-right: 0.32rem;

          &>.name {
            flex: 1; 
            white-space: nowrap;
            position: relative;
            padding-right: .4rem;
            &>.arrow{
              position: absolute;
              width: .5rem; 
              height: .8rem;
              right: 0rem;
              top: 0;
              &.open {
                background: url("~@/assets/imgs/icon_arrow_down@2x.png") no-repeat right center / 0.32rem auto;
              }

              &.close {
                background: url("~@/assets/imgs/icon_arrow_up@2x.png") no-repeat right center / 0.32rem auto;
              }
            }
            &.active {
              color: #e60027;
            }
          }

          // &>.arrow {
          //   &.open {
          //     background: url("~@/assets/imgs/icon_arrow_down@2x.png") no-repeat right center / 0.32rem auto;
          //   }

          //   &.close {
          //     background: url("~@/assets/imgs/icon_arrow_up@2x.png") no-repeat right center / 0.32rem auto;
          //   }
          // }
        }

        // & > div {
        //   flex: 0 0 auto;
        //   font-size: 0.28rem;
        //   padding: 0 0.32rem 0 0;
        //   margin-right: 0.32rem;

        //   &.open {
        //     background: url("~@/assets/imgs/icon_arrow_down@2x.png") no-repeat
        //       right center / 0.32rem auto;
        //   }

        //   &.close {
        //     background: url("~@/assets/imgs/icon_arrow_up@2x.png") no-repeat
        //       right center / 0.32rem auto;
        //   }

        //   &.active {
        //     color: #e60027;
        //   }
        // }
      }

      &>.smenu-con {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background-color: #fff;
        border-radius: 0px 0px 24px 24px;
        z-index: 11;
        padding-bottom: 0.3rem;
        padding: 0.32rem;

        &>.menu {
          display: flex;
          flex-wrap: wrap;
          margin-right: -0.24rem;
          padding-bottom: 0.32rem;
          box-sizing: border-box;

          &>.item {
            box-sizing: border-box;
            font-size: 0.26rem;
            flex: 0 0 auto;
            padding: 0.22rem 0.24rem;
            margin: 0.12rem;
            margin-right: 0.24rem;
            margin-left: 0;
            background: rgba(0, 0, 0, 0.04);
            border-radius: 0.08rem;
            text-align: center;

            &.active {
              background-color: #fff1f0;
              color: #e60027;
            }
          }
        }

        &>.boot {
          display: flex;
          justify-content: space-between;

          &>div {
            flex: 1;
            text-align: center;
            border: 0.01rem solid #f0f0f0;
            font-size: 0.3rem;
            margin-right: 0.24rem;
            border-radius: 0.08rem;
            height: 0.72rem;
            line-height: 0.72rem;

            &.ok {
              background-color: #e60027;
              color: #fff;
              margin-right: 0;
            }
          }
        }
      }
    }

    &>.filter3 {
      display: flex;
      padding: 0 0.16rem;
      height: 1.04rem;
      align-items: center;

      &>div {
        flex: 0 0 auto;
        height: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        font-size: 0.28rem;
        padding: 0 0.32rem;
        background-color: #f5f5f5;
        border-radius: 0.32rem;
        margin: 0 0.16rem;

        &.active {
          color: #e60027;
          background-color: #fff1f0;
        }
      }
    }
  }

  &>.list-con {
    padding: 0.24rem 0.08rem;
    font-size: 0.28rem;
    background-color: #f5f5f5;
    position: relative;

    // &>.vue-waterfall {
    //   display: flex;

    //   &>.vue-waterfall-column {
    //     flex: 1;
    //     margin: 0;
    //     border: 1px solid red;
    //   }

    // }
    .list {
      display: flex;
      flex-wrap: wrap;
      margin: 0.16rem 0.08rem;
      justify-content: space-between;

      &>.item {
        margin-bottom: 0.16rem;
        background-color: #fff;
        border-radius: 0.08rem;
        flex: 0 0 3.52rem;

        &>.img {
          width: 100%;
          height: 2.31rem;
          border-radius: 0.08rem;
          box-sizing: border-box;
          background: url("~@/assets/imgs/item-bg.png") no-repeat center center / 100% auto;
        }

        &>.info {
          padding: 0.24rem 0.16rem;
          padding-bottom: 0;

          &>.title {
            color: rgba(0, 0, 0, 0.85);
            padding-bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }

          &>.time {
            color: rgba(0, 0, 0, 0.45);
            font-size: 0.24rem;
            line-height: 0.4rem;
            display: none;
          }

          &>.bootom {
            display: flex;
            font-size: 0.24rem;
            color: rgba(0, 0, 0, 0.45);
            padding: 0.06rem 0;
            align-items: center;

            &>.author {
              flex: 1;
            }

            &>.view {
              flex: 0 0 0.32rem;
              height: 0.64rem;
              background: url("~@/assets/imgs/icon_see@2x.png") no-repeat left center / 0.32rem auto;
            }

            &>.count {
              flex: 0 0 auto;
              margin-left: 0.1rem;
            }
          }
        }
      }
    }
  }

  .loading {
    text-align: center;
    padding: 0.5rem;
    color: rgba(0, 0, 0, 0.45);
  }

  .mask {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.55);
    z-index: 10;
  }
}
</style>
